import type {Dispatch, SetStateAction} from 'react';

export const discardChanges = <I>(initialData: I | null, setData: Dispatch<SetStateAction<I>>) => {
    if (initialData) {
        setData(initialData);
    }
};
